import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';
import { ICON_CLOSE } from '../_style/Icon';


const useStyles = makeStyles((theme) => ({
  close: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 10,
  },
  iconClose: {
    color: theme.palette.icon.main,
  },
}));


/** 關閉按鈕 */
export function CloseButton({onClick}) {
  const classes = useStyles();
  return (
    <Box className={classes.close}>
      <ICON_CLOSE classes={classes.iconClose} mode='btn' onClick={onClick} size={{box: 'l', svg: 'm'}} />
    </Box>
  )
}